import { Box, styled, ToggleButton, Typography } from '@mui/material';
import React, { ImgHTMLAttributes } from 'react';

export const FinanceImg = styled(
  ({ alt, ...props }: ImgHTMLAttributes<HTMLImageElement>) => (
    <img alt={alt} {...props} />
  ),
)(() => ({
  height: 164,
  width: 'auto',
}));

export const FieldLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.neutral[1000],
  marginBottom: theme.spacing(0.5),
  fontSize: theme.typography.caption.fontSize,
}));

export const BlockTitleContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(1.5),
}));

export const BlockContainer = styled(Box)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1.5),
  marginBottom: theme.spacing(2),
  backgroundColor: theme.palette.neutral[100],
}));

export const FormContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  paddingBottom: theme.spacing(6),
  marginBottom: theme.spacing(-6),

  [theme.breakpoints.up('lg')]: {
    paddingBottom: theme.spacing(3),
    marginBottom: theme.spacing(-3),
  },
}));

export const ImageContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: theme.spacing(4),
  marginTop: theme.spacing(2),
}));

export const QuestionCounter = styled(Typography)(({ theme }) => ({
  color: theme.palette.neutral[600],
  textAlign: 'center',
  marginBottom: theme.spacing(1),
}));

export const QuestionTitle = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  marginBottom: theme.spacing(1),
}));

export const QuestionSubtitle = styled(Typography)<{
  component?: React.ElementType;
}>(({ theme }) => ({
  textAlign: 'center',
  marginBottom: theme.spacing(3.25),
  paddingLeft: theme.spacing(0.5),
  paddingRight: theme.spacing(0.5),
  color: theme.palette.neutral[800],
}));

export const ContentContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  paddingBottom: theme.spacing(2),
  flex: 1,
}));

export const CurrencyLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.neutral[1000],
  ...theme.typography.bodyB2Regular,
}));

export const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  height: 40,
  ...theme.typography.bodyB2Regular,
  color: theme.palette.neutral[1000],
  borderColor: theme.palette.neutral[300],
  '&.MuiToggleButton-root.Mui-selected': {
    borderColor: theme.palette.primary400.main,
    backgroundColor: theme.palette.primaries[50],
    color: theme.palette.neutral[1000],
    outline: 'none',
  },
}));
